export function formatCurrencyMX(value: number) {
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
  }).format(value);
}



// utils/money.ts
export function formatCurrencyUSD(
  value: number | string | null | undefined,
  decimals: number = 2
) {
  if (value == null) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(0);
  }

  let n: number;

  if (typeof value === 'number') {
    n = value;
  } else {
    let cleaned = String(value)
      .trim()
      .replace(/\s/g, '')
      .replace(/\$/g, '');

    const hasComma = cleaned.includes(',');
    const hasDot = cleaned.includes('.');

    if (hasComma && hasDot) {
      // 1.234,56 → europeo
      n = Number(cleaned.replace(/\./g, '').replace(',', '.'));
    } else if (hasComma) {
      // distinguir: 1,000 vs 1234,56
      const parts = cleaned.split(',');

      if (parts.length === 2 && parts[1].length === 3) {
        // miles → 1,000
        n = Number(cleaned.replace(/,/g, ''));
      } else {
        // decimal → 1234,56
        n = Number(cleaned.replace(',', '.'));
      }
    } else {
      // formato normal
      n = Number(cleaned);
    }
  }

  if (!isFinite(n) || isNaN(n)) {
    n = 0;
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(n);
}

export const sumMixedArray = (values: (string | number)[]): number => {
  return values.reduce((total:number, item) => {
    if (typeof item === "number") {
      return total + item;
    }

    if (typeof item === "string") {
      // Extrae números (enteros o decimales, positivos o negativos)
      const cleaned = item.replace(/[^0-9.-]+/g, "");

      // Si queda vacío o inválido → 0
      const num = cleaned ? Number(cleaned) : 0;

      return total + (isNaN(num) ? 0 : num);
    }

    return total;
  }, 0);
};